import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    postInvoiceBulkPreview: build.mutation({
      query: body => ({ url: '/api/v1/billing/invoice/bulk/preview', method: 'POST', body }),
    }),
  }),
})

export const { usePostInvoiceBulkPreviewMutation } = extendedApi
